module.exports = __webpack_public_path__ + "img/fundermax-new-logo.f7b03ffc.png";